import blueWave from "../../assets/blue_wave.mp4";
import LogoWhite from "../../assets/logo/logo-white.svg?react";
import { useIsCompactView } from "../../core_stores/useIsCompactViewStore";
import { WelcomeFooter } from "../welcome/components/WelcomeFooter";

export default function BlueWaveLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const isCompactView = useIsCompactView();

  return (
    <div
      className="relative w-[100dvw] h-[100dvh] overflow-hidden 
      flex flex-col z-50 bg-light-surface-primary dark:bg-dark-surface-primary"
    >
      <div className="flex-1 relative overflow-hidden">
        <video
          src={blueWave}
          autoPlay
          loop
          muted
          playsInline
          className="absolute right-0 top-0 w-full h-full 
            object-cover scale-[1.1]"
        />

        <div
          className="absolute inset-0 bg-gradient-to-t 
              from-light-surface-primary dark:from-dark-surface-primary 
              to-transparent"
        />
      </div>

      <div
        className={`${isCompactView ? "h-[400px]" : "h-[200px]"} w-full 
        bg-light-surface-primary dark:bg-dark-surface-primary`}
      />

      <div className="absolute inset-0 z-10 flex flex-col">
        <div className="p-5">
          <LogoWhite className="scale-[8.45] origin-left" />
        </div>

        <div className="flex-1 flex items-center justify-center px-6">
          {children}
        </div>

        <WelcomeFooter />
      </div>
    </div>
  );
}
